// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B2EB","title":"styles_title__3Ol3d"};